import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Flujo de gastos (3 pasos)", items: [
      { label: "1. Requisiciones", icon: "fas fa-clipboard-list", color: "#6366f1", href: "/RequisicionesGastos", desc: "Pedir insumos y autorizar", enabled: !!user.menu_gastos },
      { label: "2. Órdenes de gasto", icon: "fas fa-file-invoice-dollar", color: "#10b981", href: "/OrdenesGastos", desc: "Proveedor, precios y autorización", enabled: !!user.menu_gastos },
      { label: "3. Gastos", icon: "fas fa-receipt", color: "#f59e0b", href: "/Gastos", desc: "Pagos y gastos directos", enabled: !!user.menu_gastos },
    ]},
    { section: "Insumos", items: [
      { label: "Insumos", icon: "fas fa-boxes", color: "#0ea5e9", href: "/InsumosGastos", desc: "Existencias, salidas y kárdex", enabled: !!user.menu_gastos },
    ]},
    { section: "Catalogos", items: [
      { label: "Proveedores de gastos", icon: "fas fa-truck", color: "#14b8a6", href: "/ProveedoresGastos", desc: "Proveedores de insumos y servicios", enabled: !!user.menu_gastos },
      { label: "Categorias", icon: "far fa-list-alt", color: "#3b82f6", href: "/Categorias", desc: "Categorias de gasto", enabled: !!user.menu_gastos },
      { label: "SubCategorias", icon: "fas fa-list-ol", color: "#06b6d4", href: "/SubCategorias", desc: "Subcategorias", enabled: !!user.menu_gastos },
      { label: "Solicitantes", icon: "fas fa-user", color: "#6366f1", href: "/Solicitantes", desc: "Catalogo solicitantes", enabled: !!user.menu_gastos },
    ]},
  ];
  return (
    <MenuBotones titulo="Gastos" descripcion="Catalogos y registro de gastos" icono="fas fa-receipt" color="#f59e0b" secciones={SECCIONES} />
  );
}

export default BotonesGastos;
